export function domReady(fn) {
  if (document.readyState !== 'loading') {
    fn();
    return;
  }
  document.addEventListener('DOMContentLoaded', fn);
} //domReady(fn)

export function detectTouch(touch) {
  // console.log("detectTouch();")

  //https://medium.com/@david.gilbertson/the-only-way-to-detect-touch-with-javascript-7791a3346685
  // test this on IE - read the comments in the article RE issues
  //https://gist.github.com/adbario/4e33b07d618d499cd81eb691c746b47e#file-jquery-touch-detect-js
  //https://patrickhlauke.github.io/touch/tests/touch-feature-detect.html
  //https://stackoverflow.com/questions/21054126/how-to-detect-if-a-device-has-mouse-support
  //https://stackoverflow.com/questions/4817029/whats-the-best-way-to-detect-a-touch-screen-device-using-javascript
  //http://www.stucox.com/blog/you-cant-detect-a-touchscreen/

  if ("ontouchstart" in window) {

    // console.log("user can touch");
    $("body").removeClass('is-not-touch');
    $("body").addClass('is-touch');
    // run("touch");
    touch = true;


    //TODO REW)EW THIS - TOM, in theory this deletes hover states for touch devices
    //APPROPRIATE TO USE? - probably not

    // //https://stackoverflow.com/questions/23885255/how-to-remove-ignore-hover-css-style-on-touch-devices
    // try { // prevent exception on browsers not supporting DOM styleSheets properly
    //   for (var si in document.styleSheets) {
    //     var styleSheet = document.styleSheets[si];
    //     if (!styleSheet.rules) continue;

    //     for (var ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
    //       if (!styleSheet.rules[ri].selectorText) continue;

    //       if (styleSheet.rules[ri].selectorText.match(':hover')) {
    //         styleSheet.deleteRule(ri);
    //       }
    //     }
    //   }
    // } catch (ex) {}
    
    return touch;
  } else {
    touch = false;

    //console.log("user can use their mouse");
    $("body").removeClass('is-touch');
    $("body").addClass('is-not-touch');
    //  run("mouse");

    return touch;
  } // if ("ontouchstart" in window)

}; //detectTouch

export function SetAppHeight() {

  var $ = $ || jQuery;

  const initSubmenuHeight = () => {
    const doc = document.documentElement
    doc.style.setProperty('--submenu-height', `${window.innerHeight}px`)
  } //ainitSubmenuHeight

  const initHeadroomHeight = () => {
    // review - don't thinkgs its used?
    var headHeight = $("#site-navigation").height(); // review

    const doc = document.documentElement;
    doc.style.setProperty('--headroom-height', headHeight + 'px')
    //SetSubmenuHeight(headHeight);

  } //appHeigh

  const appHeight = () => {
    const doc = document.documentElement
    doc.style.setProperty('--site-height', `${window.innerHeight}px`)

  } //appHeigh

  window.addEventListener('resize', appHeight)
  appHeight();
  initSubmenuHeight();
  // initHeadroomHeight();

} //function SetAppHeight()


export function pad(str, max) {
  str = str.toString();
  return str.length < max ? pad("0" + str, max) : str;
}

//  
 
export function orientation(orientationValue) {

  var $ = $ || jQuery; // svs addition added based on Tom's fix

  //console.log("hello orientation function")

  function checkOrientation() {

    var winwidth = $(window).width(); // should be inner weidth
    var winheight = $(window).height(); // inner height
    // var isHorizontal;

    if (winwidth > winheight) {
      /* horizontal orientation */
      $("body").addClass('is-horizontal');
      $("body").removeClass('is-vertical');
     return orientationValue = "horizontal";

    } else {
      /* vertical orientation */
      $("body").removeClass('is-horizontal');
      $("body").addClass('is-vertical');
      return orientationValue = "vertical";

    } //else

  }
  checkOrientation(); // run initial
  // check on resize;
  window.addEventListener('resize', checkOrientation);


} // function orientation

//export function stickyClass($stickyEl){

export function stickyClass(stickyEl) {
  //  console.log("stickyClass");
  //  console.log("stickyClass(stickyEl)", $stickyEl);
  // const element = document.querySelector('.sticky-class__container');

  let parentEl = stickyEl.closest(".sticky-class__container");
  let prevParentSiblingEl = parentEl.previousElementSibling;
  //  const container = document.querySelector('.navigation__toggle-area');

  // Multiple entries are passed into the callback. This is because if the browser is busy while
  // scrolling happens, multiple entries can accumulate between invocations of this callback.
  let intersectionCallback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // console.log("If: entry", entry);

        stickyEl.classList.remove('--is-sticky');
        parentEl.classList.remove('--parent-is-sticky');

        // console.log("Element is intersecting with the container but offset no working?");
        // Element is intersecting with the container - render it to the DOM!
      } else {
        // console.log("Else: entry", entry);

        stickyEl.classList.add('--is-sticky');
        parentEl.classList.add('--parent-is-sticky');

        console.log("Element is  NOT intersecting with the container ");

        // Element is _NOT_ intersecting with the container - hide it from the DOM.
      }
    });
  };

  let options = {
    root: document.querySelector('#main'),
    rootMargin: '0px',
    threshold: 0.25 //1.0
  };
  let intersectionObserver = new IntersectionObserver(intersectionCallback, options);

  /*
  //https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
  let intersectionObserver = new IntersectionObserver(intersectionCallback, {
     root: document.querySelector('#main'),
     rootMargin: "0px 0px 1000px 0px"//"0px 0px 0% 0px"
  // root: container, // Leave this `root` out if you would like to use the device's viewport
  });
  */

  intersectionObserver.observe(prevParentSiblingEl);
}

export function fixedClass(fixedEl) {

//resovle this - not use ing yet?
  console.log("fixedClass");
  //  console.log("stickyClass(stickyEl)", $stickyEl);

  // const element = document.querySelector('.sticky-class__container');


  let parentEl = fixedEl.closest(".fixed-class__container");
  let prevParentSiblingEl = parentEl.previousElementSibling;
  //  const container = document.querySelector('.navigation__toggle-area');

  // Multiple entries are passed into the callback. This is because if the browser is busy while
  // scrolling happens, multiple entries can accumulate between invocations of this callback.
  let intersectionCallback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // console.log("If: entry", entry);

        fixedEl.classList.remove('--is-fixed');
        parentEl.classList.remove('--parent-is-fixed');

        // console.log("Element is intersecting with the container but offset no working?");
        // Element is intersecting with the container - render it to the DOM!
      } else {
        // console.log("Else: entry", entry);

        fixedEl.classList.add('--is-fixed');
        parentEl.classList.add('--parent-is-fixed');

        console.log("Element is  NOT intersecting with the container ");

        // Element is _NOT_ intersecting with the container - hide it from the DOM.
      }
    });
  };

  let options = {
    root: document.querySelector('#main'),
    rootMargin: '0px',
    threshold: 0.25 //1.0
  };
  let intersectionObserver = new IntersectionObserver(intersectionCallback, options);

  /*
  //https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
  let intersectionObserver = new IntersectionObserver(intersectionCallback, {
     root: document.querySelector('#main'),
     rootMargin: "0px 0px 1000px 0px"//"0px 0px 0% 0px"
  // root: container, // Leave this `root` out if you would like to use the device's viewport
  });
  */

  intersectionObserver.observe(prevParentSiblingEl);

}

export function previewSite() {
  // TODO  - review use of cookies, the number of buttons vs these "states"
  // preview site - if cookies diables or not on
  // console.log("previewsite function");

  $("body").attrchange({
    trackValues: true, // set to true so that the event object is updated with old & new values
    callback: function (evnt) {
      if (evnt.attributeName == "class") { // which attribute you want to watch for changes

        var $nobutton = $("#cn-refuse-cookie"),
          $yesbutton = $("#cn-accept-cookie"),
          $dotbutton = $(".cn-revoke-cookie")


        if ($('body').hasClass('cookies-accepted')) {

          $nobutton.hover(function () { // was #cn-accept-cookie /#cookie-notice

            $("body").addClass("preview-site g-scale"); //Add the active class to the area is hovered
          }, function () {

            $("body").removeClass("preview-site g-scale");
          });

          $yesbutton.hover(function () {

            //   console.log("has class cookies-accepted ")
            $("body").addClass("preview-site"); //Add the active class to the area is hovered
          }, function () {

            $("body").removeClass("preview-site");
          });

        } else if ($('body').hasClass('cookies-refused')) {

          $nobutton.hover(function () {

            $("body").addClass("preview-site g-scale"); //Add the active class to the area is hovered
          }, function () {

            $("body").removeClass("preview-site g-scale");
          });

          $yesbutton.hover(function () {
            //  console.log("has class cookies-refused ")
            $("body").addClass("preview-site"); //Add the active class to the area is hovered
          }, function () {

            $("body").removeClass("preview-site");
          });

          // preview on the dot:

          $dotbutton.hover(function () {

            $("body").addClass("preview-site"); //Add the active class to the area is hovered
          }, function () {

            $("body").removeClass("preview-site");
          });

        } else if ($('body').hasClass('cookies-not-set')) {


          $yesbutton.hover(function () { // was #cn-accept-cookie /#cookie-notice

            $("body").addClass("preview-site"); //Add the active class to the area is hovered
          }, function () {

            $("body").removeClass("preview-site");
          });

          $nobutton.hover(function () { // was #cn-accept-cookie /#cookie-notice

            $("body").addClass("preview-site g-scale"); //Add the active class to the area is hovered
          }, function () {

            $("body").removeClass("preview-site g-scale");
          });


        }

      } //== "class"

    }

  });

} //previewSite();

export function clickcookierevoke() {
  // trigger a click on the default revoke button
  $('a.th-cookie-revoke').click(function () {
    $('.cn-revoke-cookie')[0].click(); // this does
  });

} //clickcookierevoke

export function galleryimageorientation($thisitem, thisimagewidth, thisimageheight) {

  //  console.log("gallery imageorientation"+$thisitem+"");

  //item:
  var $this = $thisitem,
    thiswidth = $this.width(),
    thisheight = $this.height(),
    thiswidthtoheightratio = (thiswidth / thisheight),
    //image:
    $thisimage = $this.find('img, video'),


    thisimagewidth = thisimagewidth;

  if (thisimagewidth == undefined) {
    // console.log("thisimagewidth == undefined");

    var thisimagewidth = $thisimage.width(),
      thisimageheight = $thisimage.height();

  } else {

    var thisimagewidth = thisimagewidth,
      thisimageheight = thisimageheight;

  };

  var thisimagewidthtoheightratio = (thisimagewidth / thisimageheight);

  $this.attr("item-ratio", ""); // remove existing value
  $thisimage.attr("itemimage-ratio", ""); // remove existing value
  // set new value
  $this.attr("item-ratio", thiswidthtoheightratio);
  $thisimage.attr("itemimage-ratio", thisimagewidthtoheightratio);

  // ensure any existing classes are removed fromt this item & image classes, as it might be duplicate
  $this.removeClass("square-item image-larger-than-item vertical-item horizontal-item ratio-equal image-larger-than-item");
  $thisimage.removeClass("square-image vertical-image horizontal-image");


  if (thiswidth == thisheight) {
    //width equals height = square item

    $this.addClass("square-item");

    if (thiswidthtoheightratio == thisimagewidthtoheightratio) {
      // console.log("ratio equal")

    } else if (thiswidthtoheightratio > thisimagewidthtoheightratio) {
      //the image is larger than th container it fits within:

      $this.addClass("image-larger-than-item");

    } else if (thiswidthtoheightratio > thisimagewidthtoheightratio) {} //height ratio

  } else if (thiswidth < thisheight) {
    //vertical item


    //width smaller than height = vertical item
    $this.addClass("vertical-item");

    // console.log("thisimagewidthtoheightratio"+thisimagewidthtoheightratio+"")
    if (thiswidthtoheightratio == thisimagewidthtoheightratio) {
      // console.log("ratio equal")

    } else if (thiswidthtoheightratio > thisimagewidthtoheightratio) {
      //
      // console.log("the image is larger than th container it fits within:")

      $this.addClass("image-larger-than-item");

    } else if (thiswidthtoheightratio > thisimagewidthtoheightratio) {

    } //height ratio

  } else if (thiswidth > thisheight) {
    //width larger than height = horizontal item

    $this.addClass("horizontal-item");
    // console.log("thiswidthtoheightratio"+thiswidthtoheightratio+"")

    //console.log("thisimagewidthtoheightratio"+thisimagewidthtoheightratio+"")
    if (thiswidthtoheightratio == thisimagewidthtoheightratio) {
      // console.log("ratio equal")
    } else if (thiswidthtoheightratio > thisimagewidthtoheightratio) {
      //the image is larger than th container it fits within:

      $this.addClass("image-larger-than-item");

    } else if (thiswidthtoheightratio > thisimagewidthtoheightratio) {

    } //height ratio

  } //itemratio

  if (thisimagewidth == thisimageheight) {
    $thisimage.addClass("square-image");
  } else if (thisimagewidth < thisimageheight) {
    $thisimage.addClass("vertical-image");
  } else if (thisimagewidth > thisimageheight) {
    $thisimage.addClass("horizontal-image");
  } ///image width vs height ratio

}; //  function galleryimageorientation



export function scrollToSection($target) {

  
  // $target.css("background","red");
  // $target.scrollTop( 300 );
  // doesn't fucking work... - issuews with overflow/css maybe?
  // https://stackoverflow.com/questions/52802245/navigation-with-jquery-smooth-scroll-causes-weird-behavior
  $('#main').animate({
    // scrollTop: $target.offset().top
    // scrollTop: $target.offset().top
    scrollTop: $target.offset().top + 'px'

    
}, 10);
  

}